if (!customElements.get('load-more-button')) {
  class LoadMoreButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[data-load-more]');
      this.spinner = this.querySelector('.loading__spinner');
      this.loading = false;

      if (this.button) {
        this.button.addEventListener('click', this.onClick.bind(this));
      }
    }

    onClick(event) {
      event.preventDefault();
      if (this.loading) return;

      const url = this.getAttribute('data-url');
      if (!url) return;

      const grid = document.getElementById('product-grid');
      const sectionId = grid && grid.dataset.id;
      const fetchUrl = sectionId
        ? `${url}${url.indexOf('?') === -1 ? '?' : '&'}section_id=${sectionId}`
        : url;

      this.setLoading(true);

      fetch(fetchUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const parsed = new DOMParser().parseFromString(responseText, 'text/html');
          const newGrid = parsed.getElementById('product-grid');

          if (grid && newGrid) {
            const items = Array.from(newGrid.children);
            items.forEach((item) => item.classList.add('scroll-trigger--cancel'));
            grid.append(...items);
          }

          const nextButton = parsed.querySelector('load-more-button');
          const nextUrl = nextButton && nextButton.getAttribute('data-url');

          if (nextUrl) {
            this.setAttribute('data-url', nextUrl);
            this.setLoading(false);
          } else {
            this.remove();
          }
        })
        .catch(() => this.setLoading(false));
    }

    setLoading(state) {
      this.loading = state;
      this.classList.toggle('load-more--loading', state);

      if (this.button) {
        this.button.setAttribute('aria-busy', state ? 'true' : 'false');
      }
      if (this.spinner) {
        this.spinner.classList.toggle('hidden', !state);
      }
    }
  }

  customElements.define('load-more-button', LoadMoreButton);
}
